export const COOKIE_NAME = 'nextjs-example-ai-chat-gpt3'

// default first message to display in UI (not necessary to define the prompt)
export const initialMessages = [
  {
    who: 'bot',
    message:
      'Hi Annalese here, your AI Support Assistant. Im here to help you craft the best application. Send me your initial idea in less than 100 words, and I can provide feedback and guidance to enhance your proposal.',
  },
]
